import ViewServiceHistory from 'src/components/ViewServiceHistory/ViewServiceHistory';
import { connect } from 'react-redux';
import { IStoreState } from 'src/store';

const mapStateToProps = (state: IStoreState) => ({
    roHistory: state.ROHistory.allRoHistory.roHistory,
    custInfo: state.Customer.Customer,
    vehicles: state.Vehicles.vehicles,
    selectedVehicle: state.Vehicles.selectedVehicle,
    specData: state.Specs,
    locale: state.Framework.locale,
    theme: state.Framework.theme,
});

export default connect(mapStateToProps)(ViewServiceHistory);